import {
  birthDateMask,
  echeanceMask,
  cciNumberMask,
  ibanNumberMask,
  numberMask,
  oriasMask,
  siretMask,
  defaultMask,
  phoneMask,
} from '@/utils/mask2';

const masks = {
  cci: cciNumberMask,
  iban: ibanNumberMask,
  number: numberMask,
  currency: numberMask,
  echeance: echeanceMask,
  birthdate: birthDateMask,
  orias: oriasMask,
  siret: siretMask,
  all: defaultMask,
  tel: phoneMask,
};

const directive = {
  inserted(el, binding) {
    const methods = binding.value;
    const { options } = methods;
    let maskName = (methods.mask || 'all');
    if (!masks[maskName]) {
      maskName = 'all';
    }
    const mask = masks[maskName](el, options);
    // set initial value
    if (methods.getValue) {
      mask.value = `${methods.getValue}`;
    }
    // set new value on input change
    mask.on('accept', () => {
      if (maskName === 'currency' || maskName === 'number') {
        if (mask.unmaskedValue !== '') {
          methods.setValue(parseInt(mask.unmaskedValue || 0, 10));
        } else {
          methods.setValue(0);
        }
      } else {
        methods.setValue(mask.unmaskedValue);
      }
    });
    // force to set a new value
    if (methods.update && methods.update.allow) {
      Object.assign(methods.update, { forceUpdate: (value) => { mask.value = value; } });
    }
  },
};

export default directive;
